import styles from "./ReconcileStocks.module.scss";
import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useReconcileStocks from "./useReconcileStocks";
import { useStoreCurrency } from "../../../../../hooks/useStoreCurrency";
import { ArrowRight, SaveIcon } from "../../../../../assets/svgIcons";

const ReconcileStocks = () => {
  const {
    storeName,
    isSubmitting,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    products,
    reconciliedData,
    isSaving,
    isLoadingDiscrepancy,
    discrepancyReasons,
    isReconciliationPrompt,
    categoryList,
    filters,
    stockStatusList,
    stockCountDate,
    setStockCountDate,
    setFilters,
    submitReconciliation,
    saveDraft,
    refreshReconciliation,
    isRefreshing,
    setReconciliedData,
    handleSubmitClick,
    setIsReconciliationPrompt,
    isDraft,
    status,
  } = useReconcileStocks();
  const navigate = useNavigate();
  const { store_currency } = useStoreCurrency();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Inventory - Reconciliations"
      description="Reconcile stocks"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <div className={styles.reconcileStocks}>
          <h3>Inventory</h3>
          <div className={styles.reconcileStocks__header}>
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "20px" }}
            >
              <primaryComponents.Button
                classNames="btn btn--outline"
                onClick={() => navigate(-1)}
                type="button"
                style={{ width: "max-content" }}
              >
                <FontAwesomeIcon
                  icon="angle-left"
                  className="mr-3"
                  style={{ fontSize: "18px" }}
                />
                <span>Back</span>
              </primaryComponents.Button>
              <div>
                <h4 className="mb-0">Stock Reconciliation - {storeName}</h4>
                <p className="small-text-size">
                  Please note that this page autosave every 5 mins
                </p>
              </div>
            </div>

            <div className="d-flex ml-auto">
              <primaryComponents.Button
                classNames="btn btn--primary mr-2"
                onClick={handleSubmitClick}
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                loadingText="Submitting..."
              >
                <ArrowRight style={{ fontSize: "20px" }} className="mr-1" />
                Submit
              </primaryComponents.Button>
              <primaryComponents.Button
                classNames="btn btn--outline"
                onClick={() => saveDraft(false)}
                isDisabled={isSaving}
              >
                <SaveIcon
                  style={{ fontSize: "20px" }}
                  className="dark--text mr-1"
                />
                Save
              </primaryComponents.Button>
            </div>
          </div>

          {/* search / filter section */}
          <div
            className="d-flex justify-content-between flex-wrap"
            style={{ gap: "15px" }}
          >
            <div className={styles.reconcileStocks__search}>
              <primaryComponents.SearchField
                placeholder="Search by product name"
                value={filters?.searchQuery}
                trigger={(value) =>
                  setFilters((prev) => ({ ...prev, searchQuery: value }))
                }
                triggerOnInput={true}
                showsearchBtn
              />
            </div>
            <div className={styles.reconcileStocks__filters}>
              <div style={{ width: "50%" }}>
                <primaryComponents.SelectField
                  name="stock_status"
                  options={stockStatusList}
                  idKey="value"
                  nameKey="name"
                  value={filters?.stock_status || "Filter Stock Status"}
                  placeholder="Filter by stock status"
                  onChange={(value) => {
                    setFilters((prev) => ({ ...prev, stock_status: value }));
                  }}
                />
              </div>
              <div style={{ width: "50%" }}>
                <primaryComponents.MultipleSelectField
                  name="categories"
                  options={categoryList}
                  idKey="id"
                  nameKey="name"
                  placeholder="Select Categories"
                  onChange={(values) => {
                    let newValues = [];
                    values?.forEach((item) => {
                      newValues.push(item.value);
                    });
                    setFilters((prev) => ({ ...prev, categories: newValues }));
                  }}
                />
              </div>
            </div>
          </div>

          <div>
            <secondaryComponents.LoaderHelper
              classNames="mt-4"
              isLoading={isLoading || isLoadingDiscrepancy}
            >
              {/* autoScrollRef removed — ReconcileStockEditView handles
                  infinite scroll internally via the virtualizer */}
              <secondaryComponents.ReconcileStockEditView
                isDraft={isDraft}
                status={status}
                onRefresh={refreshReconciliation}
                isRefreshing={isRefreshing}
                store_currency={store_currency}
                products={products}
                setReconciliedData={setReconciliedData}
                reconciliedData={reconciliedData}
                discrepancyReasons={discrepancyReasons}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                fetchNextPage={fetchNextPage}
                stockCountDate={stockCountDate}
                setStockCountDate={setStockCountDate}
                action={handleSubmitClick}
                isLoading={isSubmitting}
                loadingText={"Applying..."}
              />
            </secondaryComponents.LoaderHelper>

            {/* Spinner shown below the table while the next page loads */}
            <secondaryComponents.LoaderHelper
              classNames="mt-4"
              isLoading={isFetchingNextPage && !isLoading}
            />
          </div>

          <secondaryComponents.Modal
            isActive={isReconciliationPrompt}
            closeModal={() => setIsReconciliationPrompt(false)}
            width="500px"
          >
            <secondaryComponents.ReconciliationReviewPrompt
              closeModal={() => setIsReconciliationPrompt(false)}
              reconciliationType="firstSubmission"
              proceed={() => {
                submitReconciliation();
                setIsReconciliationPrompt(false);
              }}
            />
          </secondaryComponents.Modal>
        </div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default ReconcileStocks;
